import React from "react";
import CustomSelect from "../common/Select";

const opcionesZona = [
  { value: "02", label: "URBANO" },
  { value: "01", label: "RURAL" }
];

function SelectorZona({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesZona}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Zona"
      error={error}
      required={required}
    />
  );
}

export default SelectorZona;